import { render, staticRenderFns } from "./dashboardContainer.vue?vue&type=template&id=84fe63e2&scoped=true"
import script from "./dashboardContainer.vue?vue&type=script&lang=js"
export * from "./dashboardContainer.vue?vue&type=script&lang=js"
import style0 from "./dashboardContainer.vue?vue&type=style&index=0&id=84fe63e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fe63e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84fe63e2')) {
      api.createRecord('84fe63e2', component.options)
    } else {
      api.reload('84fe63e2', component.options)
    }
    module.hot.accept("./dashboardContainer.vue?vue&type=template&id=84fe63e2&scoped=true", function () {
      api.rerender('84fe63e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/dashboardContainer/src/dashboardContainer.vue"
export default component.exports